import styled, { css } from "styled-components";
import type { SelectlistVariantsType } from "./Selectlist";

// STYLES
const selectlistWithSearch = css`
    position: relative;
    margin-block: var(--spacing-1) 0;

    @supports not (margin-block: 0) {
        margin-top: var(--spacing-1);
        margin-bottom: var(--spacing-3);
    }
`;

// COMPONENTS
export const Listbox = styled.div`
    display: none;
    position: absolute;
    top: calc(100% - 1px);
    width: 100%;
    background-color: var(--color-white);
    border: 1px solid var(--color-platinum-light);
    z-index: var(--z-index-dropdown);
`;

export const ListboxHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-2);
    border-bottom: 1px solid var(--color-platinum-light);
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--spacing-2);
    font-family: var(--font-book);
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: start;
    color: var(--color-grey-7);
    background-color: var(--color-white);
    border: 1px solid var(--color-platinum-light);

    svg,
    .dxp-icon {
        flex-shrink: 0;
    }

    &:is(:hover, :focus) {
        color: var(--color-black);
        border-color: var(--color-black);
    }

    &[aria-expanded="true"] + ${Listbox} {
        display: block;
    }
`;

export const SelectlistVariants = {
    "selectlist-with-search": selectlistWithSearch,
};

const SelectlistVariant = styled.div<{ variant: SelectlistVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${SelectlistVariants[variant]};
        `};
`;

export default SelectlistVariant;
